// extracted by mini-css-extract-plugin
export default {"separator":"ShiftCashierSeparator_separator__WArzD"};